<template>
    <div class="cc-country">
        <div class="cc-country__header">
            <div class="cc-country__title">{{ translations['Choose country to show available carriers'] }}</div>
        </div>
        <div class="cc-country__main">
            <div class="cc-form-input">
                <select id="deliveryAddress.country" name="deliveryAddress.country" class="cc-input cc-input--select" :value="selectedCountry" @change="updateCountry">
                    <option value="" disabled="disabled">{{ translations['Select country'] }}</option>
                    <option v-for="country in countries" v-bind:key="country.id" :value="country.id">{{ country.name }}</option>
                </select>
                <div class="cc-alert cc-alert--error" v-if="user.errors.deliveryAddress.country">{{ user.errors.deliveryAddress.country }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                countries: state => state.config.countries,
                selectedCountry: state => state.user.deliveryAddress.country,
                user: state => state.user,
            }),
        },
        methods: {
            updateCountry: function (event) {
                this.$store.commit('SET_ERROR_LOGIN_COUNTRY_MISMATCH', false);

                if (event.target.value === '') {
                    this.$store.dispatch('SELECT_CARRIER', null);
                    this.$store.dispatch('SELECT_PAYMENT', null);
                }

                this.$store.dispatch('UPDATE_COUNTRY', event.target.value).then(function () {
                    document.querySelector('.cc-content--carriers').scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                });
            },
        },
        name: 'Country',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/main";

    #app {
        .cc-country {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-country__header {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-country__title {
            font-size: 16px;
            display: inline-block;
        }

        .cc-country__main {
            display: block;
            width: 100%;
            max-width: 100%;
        }

        .cc-input {
            &.cc-input--select {
                width: 400px;
                padding: 1.5rem 6rem 1.5rem 1.5rem;
                background-image: url("/themes/venedor/img/country_select_button.png");
                background-size: 52px 52px;
            }
        }

        @include mobile {
            .cc-input {
                &.cc-input--select {
                    width: 100%;
                }
            }
        }
    }
</style>
